import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/components/Dashboard/Layout/DashboardLayout.vue";
import NotFound from "@/components/GeneralViews/NotFoundPage.vue";
// Dashboard pages
import Overview from "@/components/Dashboard/Views/Dashboard/Overview.vue";
import Widgets from "@/components/Dashboard/Views/Dashboard/Widgets.vue";
// Pages
import UserProfilePage from "@/components/Dashboard/Views/Pages/UserProfile.vue";
import TimeLinePage from "@/components/Dashboard/Views/Pages/TimeLinePage.vue";
// Components pages
import Buttons from "@/components/Dashboard/Views/Components/Buttons.vue";
import GridSystem from "@/components/Dashboard/Views/Components/GridSystem.vue";
import Panels from "@/components/Dashboard/Views/Components/Panels.vue";
import SweetAlert from "@/components/Dashboard/Views/Components/SweetAlert.vue";
import Notifications from "@/components/Dashboard/Views/Components/Notifications.vue";
import Icons from "@/components/Dashboard/Views/Components/Icons.vue";
import Typography from "@/components/Dashboard/Views/Components/Typography.vue";
// Forms pages
import RegularForms from "@/components/Dashboard/Views/Forms/RegularForms.vue";
import ExtendedForms from "@/components/Dashboard/Views/Forms/ExtendedForms.vue";
import ValidationForms from "@/components/Dashboard/Views/Forms/ValidationForms.vue";
import Wizard from "@/components/Dashboard/Views/Forms/Wizard.vue";
// TableList pages
import RegularTables from "@/components/Dashboard/Views/Tables/RegularTables.vue";
import ExtendedTables from "@/components/Dashboard/Views/Tables/ExtendedTables.vue";
import PaginatedTables from "@/components/Dashboard/Views/Tables/PaginatedTables.vue";
// Maps pages
import GoogleMaps from "@/components/Dashboard/Views/Maps/GoogleMaps.vue";
import FullScreenMap from "@/components/Dashboard/Views/Maps/FullScreenMap.vue";
import VectorMaps from "@/components/Dashboard/Views/Maps/VectorMapsPage.vue";
// Identity Server Pages
import IdentityNewLogin from "@/components/IdentityServer/NewLogin.vue";
import IdentityLogin from "@/components/IdentityServer/Login.vue";
import IdentityLogout from "@/components/IdentityServer/Logout.vue";
import IdentityRecovery from "@/components/IdentityServer/AccountRecovery.vue";
import IdentityLock from "@/components/IdentityServer/Lock.vue";
import IdentityConfirmationSent from "@/components/IdentityServer/ConfirmationSent.vue";
import IdentitySelfRegistration from "@/components/IdentityServer/SelfRegistration.vue";
import IdentityRecoverPassword from "@/components/IdentityServer/RecoverPassword.vue";
import IdentityNewResetPassword from "@/components/IdentityServer/NewResetPassword.vue";
import NewIdentityEmailConfirmation from "@/components/IdentityServer/NewEmailConfirmation.vue";
// Authentication Pages
import AuthenticationCallback from "@/Authentication/Callback.vue";
import OidcCallback from "@/Authentication/OidcCallback.vue";
import OidcCallbackError from "@/Authentication/OidcCallbackError.vue";
import SilentRenewOidc from "@/Authentication/SilentRenewOIDC.vue";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "@/store";
// Aileron Portal Dashboards
import AileronDashboard from "@/components/Dashboard/Views/Dashboards/ClientDashboard/Overview.vue";
import ClientCalendar from "@/components/Dashboard/Views/Dashboards/ClientDashboard/ClientCalendar.vue";
Vue.use(Router);
// Aileron Dashboard Routes
let userDashboardPage = {
    path: "/portal",
    name: "Portal",
    component: DashboardLayout,
    redirect: "/portal/client/dashboard",
    children: [
        {
            path: "client/dashboard",
            name: "AileronDashboard",
            component: AileronDashboard,
            meta: {
                title: "My Dashboard",
                isPublic: false,
                roles: ["client"]
            }
        },
        {
            path: "client/calendar",
            name: "MyEventCalendar",
            component: ClientCalendar,
            meta: {
                title: "My Upcoming Events",
                isPublic: false,
                roles: ["client"]
            }
        }
    ]
};
// OIDC Authentication Routes
let oidcCallbackAuthPage = {
    path: "/account/oidc-callback",
    name: "OidcCallback",
    component: OidcCallback,
    meta: {
        title: "OidcCallback",
        isPublic: true,
        isOidccallback: true
    }
};
let oidcCallbackErrorAuthPage = {
    path: "/account/oidc-callback-error",
    name: "OidcCallbackError",
    component: OidcCallbackError,
    meta: {
        title: "OidcCallbackError",
        isPublic: true,
        isOidccallback: false
    }
};
let oidcSilentRenewAuthPage = {
    path: "/account/oidc-silent-renew",
    name: "SilentRenewOidc",
    component: SilentRenewOidc,
    meta: {
        title: "SilentRenewOidc",
        isPublic: true,
        isOidccallback: true
    }
};
// Authentication Routes
let callbackAuthPage = {
    path: "/account/callback",
    name: "AuthenticationCallback",
    component: AuthenticationCallback,
    meta: {
        title: "Authentication Callback"
    }
};
// Identity Routes
let identityLoginPage = {
    path: "/account/old-login",
    name: "IdentityLogin",
    component: IdentityLogin,
    meta: {
        title: "Login",
        isPublic: true
    }
};
let identityNewLoginPage = {
    path: "/account/login",
    name: "IdentityNewLogin",
    component: IdentityNewLogin,
    meta: {
        title: "Login",
        isPublic: true
    }
};
let identityLogoutPage = {
    path: "/account/logout",
    name: "IdentityLogout",
    component: IdentityLogout,
    meta: {
        title: "Logout",
        isPublic: true
    }
};
let identityRecoverPassword = {
    path: "/account/recover-password",
    name: "IdentityRecoverPassword",
    component: IdentityRecoverPassword,
    meta: {
        title: "Recover Password",
        isPublic: true
    }
};
let identitySelfRegisterPage = {
    path: "/account/registration",
    name: "IdentityRegister",
    component: IdentitySelfRegistration,
    meta: {
        title: "Identity Registration",
        isPublic: true
    }
};
let identityNewEmailConfirmationPage = {
    path: "/account/confirm-email",
    name: "IdentityEmailConfirmation",
    component: NewIdentityEmailConfirmation,
    meta: {
        title: "Email Confirmation",
        isPublic: true
    }
};
let identityConfirmationSentPage = {
    path: "/account/confirmation-sent",
    name: "IdentityConfirmationSent",
    component: IdentityConfirmationSent,
    props: { emailAddress: "" },
    meta: {
        title: "Confirmation Sent",
        isPublic: true
    }
};
let identityRecoveryPage = {
    path: "/account/recover",
    name: "IdentityRecoveryPage",
    component: IdentityRecovery,
    meta: {
        title: "Account Recovery",
        isPublic: true
    }
};
let identityRecoverPasswordPage = {
    path: "/account/recover-password",
    name: "IdentityRecoveryPassword",
    component: IdentityRecoverPassword,
    meta: {
        title: "Reset Password",
        isPublic: true
    }
};
let identityNewResetPasswordPage = {
    path: "/account/reset-password",
    name: "IdentityNewResetPassword",
    component: IdentityNewResetPassword,
    meta: {
        title: "Reset Password",
        isPublic: true
    }
};
let identityLockPage = {
    path: "/account/lock",
    name: "IdpLock",
    component: IdentityLock
};
let componentsMenu = {
    path: "/components",
    component: DashboardLayout,
    redirect: "/components/buttons",
    children: [
        {
            path: "buttons",
            name: "Buttons",
            component: Buttons,
            meta: {
                title: "Buttons",
                roles: []
            }
        },
        {
            path: "grid-system",
            name: "Grid System",
            component: GridSystem,
            meta: {
                title: "GridSystem"
            }
        },
        {
            path: "panels",
            name: "Panels",
            component: Panels,
            meta: {
                title: "Panels"
            }
        },
        {
            path: "sweet-alert",
            name: "Sweet Alert",
            component: SweetAlert,
            meta: {
                title: "SweetAlert"
            }
        },
        {
            path: "notifications",
            name: "Notifications",
            component: Notifications,
            meta: {
                title: "Notifications"
            }
        },
        {
            path: "icons",
            name: "Icons",
            component: Icons,
            meta: {
                title: "Icons"
            }
        },
        {
            path: "typography",
            name: "Typography",
            component: Typography,
            meta: {
                title: "Typography"
            }
        }
    ]
};
let formsMenu = {
    path: "/forms",
    component: DashboardLayout,
    redirect: "/forms/regular",
    children: [
        {
            path: "regular",
            name: "Regular Forms",
            component: RegularForms
        },
        {
            path: "extended",
            name: "Extended Forms",
            component: ExtendedForms
        },
        {
            path: "validation",
            name: "Validation Forms",
            component: ValidationForms
        },
        {
            path: "wizard",
            name: "Wizard",
            component: Wizard
        }
    ]
};
let tablesMenu = {
    path: "/table-list",
    component: DashboardLayout,
    redirect: "/table-list/regular",
    children: [
        {
            path: "regular",
            name: "Regular Tables",
            component: RegularTables
        },
        {
            path: "extended",
            name: "Extended Tables",
            component: ExtendedTables
        },
        {
            path: "paginated",
            name: "Paginated Tables",
            component: PaginatedTables
        }
    ]
};
let mapsMenu = {
    path: "/maps",
    component: DashboardLayout,
    redirect: "/maps/google",
    children: [
        {
            path: "google",
            name: "Google Maps",
            component: GoogleMaps
        },
        {
            path: "full-screen",
            name: "Full Screen Map",
            component: FullScreenMap
        },
        {
            path: "vector-map",
            name: "Vector Map",
            component: VectorMaps
        }
    ]
};
let pagesMenu = {
    path: "/pages",
    component: DashboardLayout,
    redirect: "/pages/user",
    children: [
        {
            path: "user",
            name: "User Page",
            component: UserProfilePage
        },
        {
            path: "timeline",
            name: "Timeline Page",
            component: TimeLinePage
        }
    ]
};
const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: DashboardLayout,
            redirect: "/portal"
        },
        oidcCallbackAuthPage,
        oidcCallbackErrorAuthPage,
        oidcSilentRenewAuthPage,
        callbackAuthPage,
        userDashboardPage,
        identityLoginPage,
        identityLogoutPage,
        identityLockPage,
        identityRecoveryPage,
        identityNewResetPasswordPage,
        identityConfirmationSentPage,
        identityNewEmailConfirmationPage,
        identitySelfRegisterPage,
        identityNewLoginPage,
        identityRecoverPassword,
        identityRecoverPasswordPage,
        componentsMenu,
        formsMenu,
        tablesMenu,
        mapsMenu,
        pagesMenu,
        {
            path: "/admin",
            component: DashboardLayout,
            redirect: "/admin/overview",
            meta: {
                isPublic: true
            },
            children: [
                {
                    path: "overview",
                    name: "Overview",
                    component: Overview,
                    meta: {
                        isPublic: true
                    }
                },
                {
                    path: "widgets",
                    name: "Widgets",
                    component: Widgets
                }
            ]
        },
        { path: "*", component: NotFound }
    ]
});
if (process.env.VUE_APP_ENV != "DEV") {
    router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidcStore"));
}
else {
    // @ts-ignore
    store.state.oidcStore.user = {
        sub: "test.user@testcompany.com",
        amr: [],
        groups: [
            "IT-Admin",
            "Internal/everyone",
            "admin",
            "client",
            "IT-Admin,,,Internal/everyone,,,admin"
        ],
        given_name: "Test",
        sid: "3a08aa07-2207-470b-aeef-8efe418b6242",
        azp: "xAEgYZw8B_XapXmqDTpENWx_Ou0a",
        family_name: "User",
        email: "test.user@testcompany.com"
    };
}
export default router;
